import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { NgRedux } from '@angular-redux/store'; // <- New
import { PermissionActions } from '../../app.actions'; // <- New
import {IAppState} from "../../interfaces/appstate.interface";
import { TranslateService } from '@ngx-translate/core';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';

@Component({
  selector: 'sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css'],
})

export class SidenavComponent implements OnInit{

  navigation: any;
  test$: Observable<any>;
  subscription: any;
  sysadminSetting: any;
  store: any = {};
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private ngRedux: NgRedux<IAppState>, // <- New
    private actions: PermissionActions,
    private translate: TranslateService,
  ) {
    this.test$ = ngRedux.select('token');
    this.subscription = Observable.combineLatest([
      ngRedux.select('clientExposure'),
      ngRedux.select('clientRule'),
      ngRedux.select('clientRebalance'),
      ngRedux.select('clientOrganization'),
      ngRedux.select('clientSystem'),
      ngRedux.select('fundAssetTrades'),
      ngRedux.select('hedgeAssetTrades'),
      ngRedux.select('sysadminSetting'),
    ]).subscribe((res) => {
      this.store['clientExposure'] = res[0];
      this.store['clientRule'] = res[1];
      this.store['clientRebalance'] = res[2];
      this.store['clientOrganization'] = res[3];
      this.store['clientSystem'] = res[4];
      this.store['fundAssetTrades'] = res[5];
      this.store['hedgeAssetTrades'] = res[6];
      this.sysadminSetting = res[7];
        this.generateSidenav();
    })
  }
  ngOnInit() {
    this.router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        this.generateSidenav();
      }
    });

  }
  generateSidenav() {
    this.subscription = this.activatedRoute.children[0].url.subscribe(res => {
      this.navigation = this.router.config[0].children.filter(function(el) {
        if(el.path === res[0].path) {
          return true;
        }
        return false;
      });
      this.navigation = this.navigation[0].children && this.navigation[0].children.reduce((total, current, index, array) => {
        let current_index = total.findIndex(i => i.name === current.data.branch),
            temp = {
              name: '',
              path: '',
              payload: [{
                title: '',
                path: '',
              }],
            },
            page = {
              title: '',
              path: '',
            };
            if( current.data !== undefined) {
              let required = current.data.permissions;

              if (current_index !== -1 && this.hasPermissions(required)) {
                 page.title = current.data.title;
                 page.path = current.path;
                 total[current_index].payload.push(page);
              } else if (current.data && this.hasPermissions(required)) {
                temp.name = current.data.branch;
                temp.path = res[0].path;
                temp.payload[0].title = current.data.title;
                temp.payload[0].path = current.path;
                total.push(temp);
              }
            }
        return total;

      },[]);
    });

  }
  hasPermissions(required) {
    let gateKeeper: boolean = true;
    if (!this.sysadminSetting) {
      for (let permit of required.primary) {
        if (!this.store[permit]) {
          gateKeeper = false;
        }
      }
      for (let permit of required.secondary) {
        if (!this.store[permit]) {
          gateKeeper = false;
        }
      }
    }
    return gateKeeper;
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/components/sidenav/sidenav.component.ts